import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import client from "./api/client";
import * as kiosk from "./api/kiosk";
import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import {
  fetchVisits,
  fetchAdmins,
  fetchPatients,
  getBackendURL,
  successfulAuth,
} from "./actions/index";

// The base URL now lives on the shared api/client instance.

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#002BB8",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.classes = props;
    this.state = {
      email: "",
      password: "",
      error: "",
      isAuthenticated: false,
      badAuth: false,
      authMessage: null,
      // Set by the global 401 handler, which redirects here with ?expired=1.
      sessionExpired:
        new URLSearchParams(window.location.search).get("expired") === "1",
      // Kiosk mode (?kiosk=1): reached from the sign-in page's "Login" badge.
      // A successful sign-in establishes a kiosk station rather than a staff
      // session, and returns to /sign_in instead of the calendar.
      isKiosk:
        new URLSearchParams(window.location.search).get("kiosk") === "1",
      admin: this.props.admin,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.login = this.login.bind(this);
    this.loginReq = this.loginReq.bind(this);
  }

  componentWillMount = () => {
    // Sets the values of tags in the head
    document.title = this.state.isKiosk
      ? "Kiosk Login | Appleby Wellness"
      : "Login | Appleby Wellness";
    let metaTags = document.getElementsByTagName("meta");
    for (let i = 0; i < metaTags.length; i++) {
      if (metaTags[i].name === "description") {
        metaTags[i].content = "Login to Organica CMS";
      }
    }
  };

  componentWillReceiveProps(nextState) {
    // load in all calendar events on init
    // console.log('next state', nextState.admin)
    this.setState({
      admin: nextState.admin,
    });
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  /* Attempt to log in the user upon submit. */
  handleSubmit(event) {
    this.login().then((errorMsg) => {
      // console.log("submit hit");
      // Redirect and save username if no errors with login.
    });
  }

  login() {
    var promise = new Promise((resolve) => {
      var payload = {
        email: this.state.email,
        password: this.state.password,
      };
      this.loginReq(resolve, payload);
    });
    return promise;
  }

  handleTempSubmit = () => {
    const { history } = this.props;
    history.push("/calendar");
  };

  loginReq(resolve, payload) {
    if (this.state.isKiosk) {
      // Establish a kiosk station: store the long-lived station token and go
      // back to the sign-in page. Deliberately does NOT set localStorage.token,
      // dispatch successfulAuth, or trip the calendar redirect — the tablet is
      // not a staff session.
      kiosk
        .stationLogin(payload.email, payload.password)
        .then((response) => {
          kiosk.storeStationToken(response.token);
          resolve("");
          this.props.history.push("/sign_in");
        })
        .catch((error) => {
          this.setState({
            badAuth: true,
            authMessage: error.isRateLimited
              ? "Too many sign-in attempts. Please wait a few minutes and try again."
              : error.message,
          });
          resolve(error.message);
        });
      return;
    }

    // skipAuthRedirect: a failed login is a 401, and letting the global handler
    // redirect would bounce the user off the page they are already on.
    client
      .post("/users/login", payload, { skipAuthRedirect: true })
      .then((response) => {
        resolve("");
        this.props.successfulAuth(
          response.data.user.email,
          response.data.user._id,
          response.data.user.name,
          response.data.user.permissions
        );
        localStorage.setItem("token", response.data.token);
        this.setState({ isAuthenticated: true, authMessage: null });
        this.props.fetchAdmins();
      })
      .catch((error) => {
        // Login is rate limited (5 per 15 minutes per IP + email). Without a
        // distinct message a throttled user just sees "wrong password" and keeps
        // trying, which is exactly what the limit is there to stop.
        this.setState({
          badAuth: true,
          authMessage: error.isRateLimited
            ? "Too many sign-in attempts. Please wait a few minutes and try again."
            : error.message,
        });
        resolve(error.message);
      });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        {/* Kiosk mode never redirects to the calendar: an admin may establish a
            station even while holding a staff session. */}
        {!this.state.isKiosk && this.state.admin.loggedIn && (
          <Redirect to="/calendar" />
        )}
        <ThemeProvider theme={theme}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{ marginTop: 100, padding: 20 }}
          >
            <Grid item xs={12} sm={4}>
              <Typography variant="subtitle2" style={{ textAlign: "left" }}>
                {this.state.isKiosk ? "KIOSK STATION" : "WELCOME TO"}
              </Typography>
              <Typography
                variant="h4"
                style={{ textAlign: "left", marginTop: 20 }}
              >
                {this.state.isKiosk ? "Kiosk Login" : "Appleby Wellness Clinic"}
              </Typography>
              {this.state.isKiosk && (
                <Typography
                  variant="body2"
                  style={{ textAlign: "left", marginTop: 12, color: "gray" }}
                >
                  Sign in to connect this tablet as a kiosk station.{" "}
                  <Link to="/sign_in" style={{ color: "#002BB8" }}>
                    Back to sign-in
                  </Link>
                </Typography>
              )}
              <br />
              <hr style={{ opacity: "20%" }} />
              <br />
              <TextField
                ref="email"
                label="Email"
                id="margin-none"
                className="email"
                onChange={this.handleEmailChange}
                style={{ width: "100%", marginTop: 50 }}
                variant={"outlined"}
              />
              <br />
              <br />
              <br />
              <TextField
                id="outlined-adornment-password"
                variant="outlined"
                type={this.state.showPassword ? "text" : "password"}
                label="Password"
                value={this.state.password}
                className="password"
                onChange={this.handlePasswordChange}
                style={{ width: "100%", borderRadius: 20 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={this.handleClickShowPassword}
                      >
                        {this.state.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <br />
              {this.state.sessionExpired && !this.state.badAuth && (
                <p style={{ color: "#8a6d3b" }}>
                  Your session has expired. Please sign in again.
                </p>
              )}
              {this.state.badAuth && (
                <p style={{ color: "red" }}>
                  {this.state.authMessage || "Invalid Information"}
                </p>
              )}

              <Button
                style={{
                  marginTop: 50,
                  width: 120,
                  borderRadius: 20,
                  color: "002BB8",
                }}
                type="submit"
                variant="contained"
                disableElevation
                color="primary"
                onClick={this.handleSubmit}
              >
                Log in
              </Button>
              <br />
              <br />
              <hr style={{ opacity: "20%" }} />
            </Grid>
          </Grid>
          <Link
            id="Login"
            to={"/forgot"}
            style={{ textAlign: "center", textDecoration: "none" }}
          >
            <Typography
              variant="body2"
              style={{ color: "gray", marginTop: 25 }}
            >
              Forgot Password
            </Typography>
          </Link>
        </ThemeProvider>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    admin: state.admin,
  };
}
export default connect(mapStateToProps, {
  fetchVisits,
  fetchAdmins,
  fetchPatients,
  successfulAuth,
})(Login);
